<template>
  <div class="addPropertyEnterprisePeopleInfo">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="back">{{$t('lang.btn_wj_returnNews')}}</el-button>
      </div>
      <el-form :model="ruleForm" name="frm" :rules="rules" ref="ruleForm" class="wid100"
        :label-width="require('@/config/enum').c_ws12" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item tem label="人员姓名" prop="personName">
          <el-input v-model="ruleForm.personName" placeholder="请输入人员姓名" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item label="人员性质" prop="personType">
          <el-select v-model="ruleForm.personType" placeholder="请选择">
            <el-option v-for="item in personType" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="职务" prop="personJob">
          <el-input v-model="ruleForm.personJob" placeholder="请输入职务" class="item-input" maxlength="15">
          </el-input>
        </el-form-item>
        <el-form-item tem label="联系电话" prop="personPhone">
          <el-input v-model="ruleForm.personPhone" placeholder="请输入联系电话" class="item-input" maxlength="15">
          </el-input>
        </el-form-item>

        <el-form-item label="证件类型" prop="certificateType">
          <el-select v-model="ruleForm.certificateType" placeholder="请选择">
            <el-option v-for="item in certificateType" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="证件号码" prop="certificateNum">
          <el-input v-model="ruleForm.certificateNum" placeholder="请输入证件号码" class="item-input">
          </el-input>
        </el-form-item>
        <el-form-item label="身份证（正面）" prop="certificatePhotoIn" ref="certificatePhotoIn">
          <upload-file ref="uploading" :accept="accept" upTypes="1" :fileList="certificatePhotoInList"
            @outputFile="getCertificatePhotoIn"></upload-file>
        </el-form-item>
        <el-form-item label="身份证（背面）" prop="certificatePhotoOut" ref="certificatePhotoOut">
          <upload-file ref="uploading" :accept="accept" upTypes="1" :fileList="certificatePhotoOutList"
            @outputFile="getCertificatePhotoOut"></upload-file>
        </el-form-item>
        <!-- 按钮 -->
        <el-button class="btn-first" @click="resetForm('ruleForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" type="primary" :disabled="isDisabled" @click="save('ruleForm')">
          {{$t('lang.btn_save')}}
        </el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:addPropertyEnterprisePeopleInfo
   *@Description:添加人员基本信息
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  import {
    mapGetters
  } from 'vuex'
  import UploadFile from '../../components/upload_file.vue'
  export default {
    data() {
      return {
        formId: '', // 企业信息id（添加人员信息必须有企业信息id）
        userId: '', // 人员id（编辑）
        flag: false, // 新增编辑表示（false新增，true编辑）
        isDisabled: true, // 保存的可点击
        certificatePhotoInList: [], // 法人身份证正面图片
        certificatePhotoOutList: [], // 法人身份证背面图片
        saveData: '',
        accept: '.jpg, .jpeg, .png',
        personType: this.$i18n.t('lang.personType'),
        certificateType: this.$i18n.t('lang.certificateType'),
        rules: {
          personName: [{
            required: true,
            message: '请输入人员姓名',
            trigger: 'blur'
          }],
          personType: [{
            required: true,
            message: '请选择人员性质',
            trigger: 'change'
          }],
          personPhone: [{
            pattern: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/,
            message: '请输入正确的电话号码（座机号格式：010-88888888）',
            trigger: 'blur'
          }],
          certificateType: [{
            required: true,
            message: '请选择证件类型',
            trigger: 'change'
          }],
          certificateNum: [{
            required: true,
            message: '请输入证件号码',
            trigger: 'blur'
          },
          { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: '请输入正确的身份证号码',
            trigger: 'blur'
          }],
          // certificatePhotoIn: [{
          //   required: true,
          //   message: '请上传身份证照片（正面）',
          //   trigger: 'change'
          // }],
          // certificatePhotoOut: [{
          //   required: true,
          //   message: '请上传身份证照片（背面）',
          //   trigger: 'change'
          // }],
        },
        ruleForm: {
          personName: '', // 人员名称
          personType: '', // 人员性质
          personJob: '', // 人员职务
          personPhone: '', // 人员电话
          certificateType: '', // 证件类型
          certificateNum: '', // 证件号码
          certificatePhotoIn: '',
          certificatePhotoOut: '',
        },
      }
    },
    components: {
      'upload-file': UploadFile
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          // ruleForm数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            // 没变
            this.isDisabled = true
          } else {
            // 变了
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      },
      'ruleForm.partyMemberNum': function (a, b) {
        if (!isNaN(parseFloat(a))) {
          this.ruleForm.partyMemberNum = a - 0
        }
      },
      'ruleForm.committeeMemberNum': function (a, b) {
        if (!isNaN(parseFloat(a))) {
          this.ruleForm.committeeMemberNum = a - 0
        }
      }
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    created() {
      this.formId = this.$route.query.formId
      let flag = this.$route.query.flag
      this.flag = flag
      if (flag) {
        // 编辑
        var rowData = this.$route.query.rowData
        this.ruleForm.personName = rowData.personName
        this.ruleForm.personType = rowData.personType
        this.ruleForm.personJob = rowData.personJob
        this.ruleForm.personPhone = rowData.personPhone
        this.ruleForm.certificateType = rowData.certificateType
        this.ruleForm.certificateNum = rowData.certificateNum
        this.ruleForm.certificatePhotoIn = rowData.certificatePhotoIn
        this.ruleForm.certificatePhotoOut = rowData.certificatePhotoOut
        this.userId = rowData.id
        this.isDisabled = true
        let arr1 = []
        let arr2 = []
        arr1.push({
          name: '',
          url: rowData.certificatePhotoIn
        })
        arr2.push({
          name: '',
          url: rowData.certificatePhotoOut
        })
        this.certificatePhotoInList = arr1
        this.certificatePhotoOutList = arr2
      }
    },
    methods: {
      // 删除身份证照片（正面）
      removeFile1(e) {
        this.isDisabled = false
        this.ruleForm.certificatePhotoIn = ''
        this.certificatePhotoInList = []
      },
      // 删除身份证照片（背面）
      removeFile2(e) {
        this.isDisabled = false
        this.ruleForm.certificatePhotoOut = ''
        this.certificatePhotoOutList = []
      },
      // 身份证照片（正面）
      getCertificatePhotoIn(e) {
        console.log(e)
        this.ruleForm.certificatePhotoIn = e
      },
      // 身份证照片（背面）
      getCertificatePhotoOut(e) {
        console.log(e)
        this.ruleForm.certificatePhotoOut = e
      },
      // 返回上一级
      back() {
        this.$router.push({
          name: 'propertyEnterpriseInfo'
        })
      },
      // 保存
      save(formName) {
        let params = this.ruleForm
        params.gardenId = this.gardenId
        params.companyId = this.formId
        console.log('params', params)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let loading = this.$loading()
            if (!this.flag) {
                this.$post('/gardenDrawCompanyPerson', params).then(
                  res => {
                    loading.close()
                    console.log(res)
                    if (res && res.errCode === 0) {
                      this.$message.success(this.$i18n.t('lang.lab_save_success'))
                      localStorage.setItem('isBack', true)
                      this.$router.push({
                        name: 'propertyEnterpriseInfo'
                      })
                    }
                  },
                  error => {
                    loading.close()
                    this.$message.error(error)
                  }
                )
            } else {
              this.$patch(`/gardenDrawCompanyPerson/${this.userId}`, params).then(
                  res => {
                    loading.close()
                    console.log(res)
                    if (res && res.errCode === 0) {
                      this.$message.success(this.$i18n.t('lang.lab_save_success'))
                      localStorage.setItem('isBack', true)
                      this.$router.push({
                        name: 'propertyEnterpriseInfo'
                      })
                    }
                  },
                  error => {
                    loading.close()
                    this.$message.error(error)
                  }
                )
            }
          } else {
            return false
          }
        })
      },
      // 清空
      resetForm(formName) {
        this.ruleForm.creditCode = ''
        this.ruleForm.enterpriseName = ''
        this.ruleForm.enterpriseSimpleName = ''
        this.ruleForm.hasParty = ''
        this.ruleForm.partyType = ''
        this.ruleForm.foundDate = ''
        this.ruleForm.leader = ''
        this.ruleForm.partyMemberNum = ''
        this.ruleForm.committeeMemberNum = ''
      }

    },
  }
</script>

<style lang="scss">
  .addPropertyEnterprisePeopleInfo {

    .item-input,
    .el-select,
    .el-date-editor.el-input {
      width: 30%;
    }

    .editor-width {
      width: 80%;
    }

    .item-select {
      display: inline-block
    }

    .empty-input {
      display: none
    }
  }
</style>